module.exports = __webpack_public_path__ + "static/specter-cp-9d4a47140112be1224fd3eca6f5f5a46.jpg";